import { observer } from 'mobx-react-lite';
import React from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../colorVars';
import { modifySoftOrder } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/modifySoftOrders';
import { updatePlugins } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/updatePlugins';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import { EditableTableField } from '../../../../../../../atomic/inputs/editableTableField/EditableTableField';
import { Body3 } from '../../../../../../../atomic/text/Text';
import { IndividualPanelHeader } from '../IndividualPanelHeader';
import style from '../IndividualTacticStyle.module.css';

export const CandleTrailTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const tacticId = tradePlan.exitTactics['CANDLE_TRAIL']?.tacticId ?? null;
    const inPosition = tradePlan?.inPosition ?? null;
    const softOrder = tradePlanStore.softOrdersById[tacticId] ?? null;
    const candleDuration = softOrder?.value.tacticValue.candleDuration ?? null;
    const timeUnit = softOrder?.value.tacticValue.timeUnit ?? null;
    const breakBy = softOrder?.value.tacticValue.breakBy ?? null;
    const updateSoftOrder = (type, value) => {
      modifySoftOrder({ softOrder, type, value });
    };

    const updateTactic = (field, newValue) => {
      updatePlugins(
        'tactic',
        { [field]: newValue },
        'CANDLE_TRAIL',
        tradePlanId,
        null
      );
    };
    if (!tradePlan?.exitTactics['CANDLE_TRAIL']) return null;
    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <IndividualPanelHeader />
            {inPosition && softOrder ? (
              <tbody>
                <tr>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Candle Duration
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={candleDuration}
                      updateValue={(newValue) =>
                        updateSoftOrder('candleDuration', newValue)
                      }
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />
                  </td>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      {'Time Unit(read-only)'}
                    </Body3>
                  </td>
                  <td className={style.labelTd}>
                    {/* <TableSelect
                      color={colors.lightGrey}
                      backgroundColor={colors.black}
                      value={timeUnit}
                      onChange={(newValue) =>
                        updateSoftOrder('timeUnit', newValue)
                      }
                      options={[
                        { label: 'Minute', value: 'MINUTES' },
                        { label: 'Day', value: 'DAYS' },
                        { label: 'Week', value: 'WEEKS' },
                        { label: 'Month', value: 'MONTHS' },
                        { label: 'Quarter', value: 'QUARTERS' },
                        { label: 'Year', value: 'YEARS' },
                      ]}
                    /> */}
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      {timeUnit}
                    </Body3>
                  </td>
                </tr>
                <tr>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Break By
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    <Body3
                      fontWeight={700}
                      color={colors.lightGrey}
                      margin="3px 3px 0 0"
                    >
                      $
                    </Body3>
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={breakBy}
                      updateValue={(newValue) =>
                        updateSoftOrder('breakBy', newValue)
                      }
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Candle Duration
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={
                        tradePlan.exitTactics['CANDLE_TRAIL'].candleDuration
                      }
                      updateValue={(newValue) =>
                        updateTactic('candleDuration', newValue)
                      }
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />
                  </td>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      {'Time Unit(read-only)'}
                    </Body3>
                  </td>
                  <td className={style.labelTd}>
                    {/* <TableSelect
                  color={colors.lightGrey}
                  backgroundColor={colors.black}
                  value={tradePlan.exitTactics['CANDLE_TRAIL'].timeUnit}
                  onChange={(newValue) =>
                    updateTactic('timeUnit', newValue)
                  }
                  options={[
                    { label: 'Minute', value: 'MINUTES' },
                    { label: 'Day', value: 'DAYS' },
                    { label: 'Week', value: 'WEEKS' },
                    { label: 'Month', value: 'MONTHS' },
                    { label: 'Quarter', value: 'QUARTERS' },
                    { label: 'Year', value: 'YEARS' },
                  ]}
                /> */}
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      {tradePlan.exitTactics['CANDLE_TRAIL'].timeUnit}
                    </Body3>
                  </td>
                </tr>
                <tr>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Break By
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    <Body3
                      fontWeight={700}
                      color={colors.lightGrey}
                      margin="3px 3px 0 0"
                    >
                      $
                    </Body3>
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={
                        tradePlan.exitTactics['CANDLE_TRAIL'].breakBy
                      }
                      updateValue={(newValue) =>
                        updateTactic('breakBy', newValue)
                      }
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            )}
          </table>
        </div>
      </TabPanel>
    );
  }
);

CandleTrailTacticPanel.tabsRole = 'TabPanel';
